


























import { Component, Ref, Vue } from "vue-property-decorator";
import CustomFormDataTableDetail from "@/components/CustomForm/TableDetail/index.vue";
import {
  AttachmentHostType,
  AuditFlowScope,
  CustomFormType,
} from "@/api/appService";
import api from "@/api/index";
import ExportWord from "@/components/DownloadWord/index.vue";
import AuditBlock, {AuditApi} from "@/components/Audit/AuditBlock.vue";


@Component({
  name: "CustomFormStandardDetail",
  components: {
    CustomFormDataTableDetail,
    ExportWord,
    AuditBlock,
  },
})
export default class CustomFormStandardDetail extends Vue {


  private dataId!: string;
  private formId!: string;

  private isProject = false;

  isReady = false;

  selector = "detail-wrap";
  filename = "";
  defaultName = "合作方申请表-";
  styles = "";

  get hostType() {
    return CustomFormType.OrganizationUnit;
  }
  created() {
    this.dataId = this.$route.query.id as string;
    this.formId = this.$route.query.formId as string;

    this.isProject = true;

    if ((this.dataId && this.hostType) || this.formId) {
      this.isReady = true;
    } else {
      this.$message.error("缺少url参数 id 或 hostType，请检查!");
    }
  }


  get auditApi(){
    return {
      canAudit: api.organizationUnit.canAudit,
      userAudit: api.organizationUnit.audit
    } as AuditApi
  }

  getData() {
    return api.organizationUnit
      .get({ id: parseInt(this.dataId) })
      .then((res) => {
        console.log("1231232", "res");
        this.filename = this.defaultName + res.displayName;

        return res;
      });
  }

  // 返回
  private cancel() {
    this.$router.back();
  }
}
